import React, { useState } from 'react';
import { heroCode, brand } from '../mock';

const tokens = (line) => {
  // very light syntax highlighting
  let html = line
    .replace(/(\/\/.*$)/g, '<span class="text-[#8a8a8a]">$1</span>')
    .replace(/('[^']*')/g, '<span class="text-[#2f9e7a]">$1</span>')
    .replace(/\b(import|export|const|new|from|true|false)\b/g, '<span class="text-[#9a4bb3]">$1</span>')
    .replace(/\b(Agent|tools)\b/g, '<span class="text-[#2d6bbf]">$1</span>');
  return { __html: html };
};

const files = [
  { name: 'lead-gen.config.ts', active: true },
  { name: 'support.config.ts', active: false },
  { name: 'onboarding.json', active: false },
];

const sidebar = [
  { label: 'client-project', depth: 0, folder: true },
  { label: 'agents', depth: 1, folder: true },
  { label: 'lead-gen.config.ts', depth: 2, active: true },
  { label: 'support.config.ts', depth: 2 },
  { label: 'workflows', depth: 1, folder: true },
  { label: 'onboarding.json', depth: 2 },
  { label: 'package.json', depth: 1 },
];

const CodeCard = () => {
  const [activeFile, setActiveFile] = useState(files[0].name);

  return (
    <div className="relative max-w-4xl mx-auto">
      <div className="absolute -inset-6 bg-gradient-to-br from-[#E08C5F]/10 to-transparent rounded-[28px] blur-2xl pointer-events-none" />
      <div className="relative rounded-2xl bg-white border border-ink-10 overflow-hidden soft-card">
        {/* Window chrome */}
        <div className="flex items-center gap-2 px-4 py-3 border-b border-ink-10 bg-[#F7F2EA]">
          <span className="w-3 h-3 rounded-full bg-[#ED6A5E]" />
          <span className="w-3 h-3 rounded-full bg-[#F5BF4F]" />
          <span className="w-3 h-3 rounded-full bg-[#62C554]" />
          <span className="ml-3 text-[12px] text-muted">{brand.name}</span>
        </div>

        <div className="grid grid-cols-[180px_1fr] min-h-[360px]">
          {/* Sidebar */}
          <aside className="bg-[#FBF7F1] border-r border-ink-10 p-3 text-[12.5px] hidden sm:block">
            {sidebar.map((s, i) => (
              <div
                key={i}
                className={`px-2 py-1 rounded-md flex items-center gap-1.5 ${
                  s.active ? 'bg-[#FCE7D6] text-[#8a3a1c]' : 'text-ink/70 hover:text-ink'
                }`}
                style={{ paddingLeft: 8 + s.depth * 10 }}
              >
                <span className={`w-2 h-2 rounded-sm ${s.folder ? 'bg-[#C2603A]/60' : 'bg-ink/20'}`} />
                <span className="truncate">{s.label}</span>
              </div>
            ))}
          </aside>

          {/* Code area */}
          <div className="flex flex-col">
            <div className="flex items-center gap-0 border-b border-ink-10 bg-[#FBF7F1] text-[12px]">
              {files.map((f) => (
                <button
                  key={f.name}
                  onClick={() => setActiveFile(f.name)}
                  className={`px-3 py-2 border-r border-ink-10 ${
                    activeFile === f.name ? 'bg-white text-ink' : 'text-ink/60 hover:text-ink'
                  }`}
                >
                  {f.name}
                </button>
              ))}
            </div>
            <pre className="mono text-[13px] leading-[1.7] p-4 overflow-x-auto code-scroll bg-white">
              {heroCode.map((l) => (
                <div key={l.n} className="flex gap-4">
                  <span className="select-none text-ink/30 w-5 text-right">{l.n}</span>
                  <code className="text-ink" dangerouslySetInnerHTML={tokens(l.t || '\u00A0')} />
                </div>
              ))}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodeCard;
